import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyStaff = Loadable({
    loader: () => import("pages/Staff/index"),
    loading: () => <PageLoader />,
});

function StaffRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyStaff />} />
        </Routes>
    );
}

export default StaffRoute;
